/*!
 * Override ajax method to set non-get request data to json if no contentType is set.
 * The reason of it is that sending data in url encoded format is unreliable and can cause issues with some APIs.
 *  (e.g. when sending a large array, the array becomes an object and the API may not be able to handle it)
 */

/**
 * @typedef {Object} AjaxOverrideOptions
 * @property {boolean} enabled
 */

/**
 * @pageOption {AjaxOverrideOptions} ajaxOverride
 * @webSetting {AjaxOverrideOptions} ajaxOverride
 */

const _ajax = $.ajax;

$.ajax = function (url, options) {
  ajaxSetup(url, options);

  return _ajax.apply(this, [url, options]);
};

const DEFAULT_CONTENT_TYPE = "application/json; charset=utf-8";
const METHODS_TO_CONVERT_TO_JSON = ["post", "put", "patch", "delete"];
const INVALID_DATA_TYPES = [FormData, File, Blob, ArrayBuffer, Uint8Array];

const overrideOptions = ajaxOverrideOptions();

function ajaxSetup(url, options) {
  if (!overrideOptions.enabled) return;

  if (!options && typeof url === "object") {
    options = url;
    url = undefined;
  }

  if (!options || typeof options !== "object") return;
  if (options.processData === false) return;
  if (options.type && typeof options.type !== "string") return;
  if (options.method && typeof options.method !== "string") return;
  if (options.contentType !== undefined && typeof options.contentType !== "string") return;
  if (!options.data || typeof options.data !== "object") return;
  if (INVALID_DATA_TYPES.some(type => options.data instanceof type)) return;

  const type = (options.method || options.type)?.toLowerCase();

  if (!METHODS_TO_CONVERT_TO_JSON.includes(type)) return;

  let contentType = options.contentType?.toLowerCase();

  if (!contentType) {
    contentType = DEFAULT_CONTENT_TYPE;
    options.contentType = contentType;
  }

  if (!contentType.includes("application/json")) return;

  options.data = JSON.stringify(options.data);
}

/**
 *
 * @returns {AjaxOverrideOptions}
 */
function ajaxOverrideOptions() {
  return {
    enabled: false,
    ...(Ingtech.webSettings?.web?.ajaxOverride || {}),
    ...(Ingtech.pageOptions?.ajaxOverride || {}),
  };
}
